<template>
  <section class="display-stats-panel">
    <article
      v-for="(stat, index) in stats"
      :key="index"
      class="stat-card"
    >
      <p class="stat-label">{{ stat.label }}</p>
      <p class="stat-value">{{ stat.value }}</p>
      <p class="stat-hint">{{ stat.hint }}</p>
    </article>
  </section>
</template>

<script>
export default {
  name: "DisplayStatsPanel",
  props: {
    stats: {
      type: Array,
      default: () => [
        { label: "Live Displays", value: 12, hint: "Active across campuses" },
        { label: "Pending Updates", value: 4, hint: "Awaiting content sync" },
        { label: "Templates", value: 23, hint: "Curated layouts ready" },
        { label: "AI Credits", value: "2.3k", hint: "Estimated monthly usage" },
      ],
    },
  },
};
</script>

<style lang="scss" scoped>
.display-stats-panel {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .stat-label {
    font-size: 13px;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .stat-value {
    font-size: 28px;
    font-weight: 600;
    color: #111827;
  }

  .stat-hint {
    font-size: 13px;
    color: #9ca3af;
  }
}
</style>
